module.exports = __webpack_public_path__ + "img/IlluBlastFAQ_Ampoule.03eaa2cb.png";